import SectionHeading from '../shared/SectionHeading';
import { TEXT_STYLES, BORDER_STYLES } from '../../constants/styles';

function ProjectChallenge({ title = 'Challenges', description, problemAreas = [], problemIds = [], headerBackground = '#213553' }) {
  if (!description && (!problemAreas || problemAreas.length === 0)) return null;

  const scrollToSection = (e, sectionId) => {
    e.preventDefault();
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <div id="challenge" className="space-y-6 mb-16 scroll-mt-32">
      <div className={`bg-[#F7F7F7] ${BORDER_STYLES.rounded} p-8 md:p-12 ${BORDER_STYLES.default}`}>
        <div className="prose prose-lg">
        {title && <SectionHeading>{title}</SectionHeading>}
        {description && (
          <p className={`${TEXT_STYLES.body} mb-6`}>
            {description}
          </p>
        )}
        {problemAreas && problemAreas.length > 0 && (
          <div className="space-y-3">
            <ol className="list-none space-y-3 pl-0">
              {problemAreas.map((area, index) => {
                const problemId = problemIds[index];
                return (
                  <li key={index}>
                    {problemId ? (
                      <button
                        onClick={(e) => scrollToSection(e, problemId)}
                        className="w-full flex items-center gap-3 px-4 py-3 rounded-full bg-white border border-[#E5E5E5] transition-colors text-left cursor-pointer"
                        style={{ 
                          '--hover-border-color': headerBackground 
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.borderColor = headerBackground;
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.borderColor = '#E5E5E5';
                        }}
                      >
                        <span 
                          className="flex-shrink-0 w-8 h-8 rounded-full text-white font-medium text-sm flex items-center justify-center"
                          style={{ backgroundColor: headerBackground }}
                        >
                          {index + 1}
                        </span>
                        <span className="text-base text-[#666666] font-normal leading-relaxed flex-1">
                          {area}
                        </span>
                      </button>
                    ) : (
                      <div className="flex items-center gap-3 px-4 py-3 rounded-full bg-white border border-[#E5E5E5]">
                        <span 
                          className="flex-shrink-0 w-8 h-8 rounded-full text-white font-medium text-sm flex items-center justify-center"
                          style={{ backgroundColor: headerBackground }}
                        >
                          {index + 1}
                        </span>
                        <span className="text-base text-[#666666] font-normal leading-relaxed flex-1">
                          {area}
                        </span>
                      </div>
                    )}
                  </li>
                );
              })}
            </ol>
          </div>
        )}
        </div>
      </div>
    </div>
  );
}

export default ProjectChallenge;

